import {
  EMPLOYEE_STATUS_ICONS,
  getEmployeeStatusIconColor,
} from '../../../shared/constants/employee-status-icons.constants';

/**
 * Action Alert status configuration for the table
 */
export const ACTION_ALERT_CONFIG = {
  iconByValue: {
    attention: 'error', // Material Icon - filled exclamation mark
    none: '',
  } as const,
  iconClassByValue: {
    attention: 'text-red-500',
    none: '',
  } as const,
  labelByValue: {
    attention: 'Attention Req!',
    none: '',
  } as const,
  textClassByValue: {
    attention: 'text-white',
    none: 'text-white',
  } as const,
  fontWeightByValue: {
    attention: 'font-normal',
    none: 'font-normal',
  } as const,
};

/**
 * Employee Status configuration for the table
 */
const EMPLOYEE_STATUS_LABEL_CLASS =
  'text-white [font-family:Inter] text-[18px] font-normal leading-[22px]';

function employeeStatusToDisplay(status: string): string {
  const key = status?.trim() ?? '';
  if (Object.prototype.hasOwnProperty.call(EMPLOYEE_STATUS_ICONS, key)) return key;
  return key.replace(/([A-Z])/g, ' $1').trim();
}

const employeeStatusImageUrlByValue: Record<string, string> = {};
const employeeStatusIconByValue: Record<string, string> = {};
const employeeStatusLabelByValue: Record<string, string> = {};
const employeeStatusFontWeightByValue: Record<string, string> = {};
const employeeStatusTextClassByValue: Record<string, string> = {};
const employeeStatusIconClassByValue: Record<string, string> = {};

for (const [status, value] of Object.entries(EMPLOYEE_STATUS_ICONS)) {
  if (value.startsWith('/')) {
    employeeStatusImageUrlByValue[status] = value;
  } else {
    employeeStatusIconByValue[status] = value;
  }
  employeeStatusIconClassByValue[status] = getEmployeeStatusIconColor(status);
  employeeStatusLabelByValue[status] = status;
  employeeStatusFontWeightByValue[status] = 'font-normal';
  employeeStatusTextClassByValue[status] = EMPLOYEE_STATUS_LABEL_CLASS;
}

export const EMPLOYEE_STATUS_CONFIG = {
  value: (_row: unknown, raw: unknown) => employeeStatusToDisplay(String(raw ?? '')),
  imageUrlByValue: employeeStatusImageUrlByValue,
  iconByValue: employeeStatusIconByValue,
  iconClassByValue: employeeStatusIconClassByValue,
  labelByValue: employeeStatusLabelByValue,
  textClassByValue: employeeStatusTextClassByValue,
  fontWeightByValue: employeeStatusFontWeightByValue,
  iconWrapperClass: 'h-6 w-6 min-w-6',
  iconFontSizeClass: 'text-[24px]',
};

